define('rebrush/components/blocks/hero-slider',[
	'jquery',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'rebrush/system/layout/responsive-hub'
], function(
	$,
	Component,
	BEM,
	ResponsiveHub
) {
	return Component.create({
		blocks: null,

		$init: function() {
			this.blocks = BEM.block('hero-slider');
			this.blocks.each(function() {
				var block = BEM.block(this),
					headlines = block.getElements('headline'),
					sublines = block.getElements('subline'),
					maxSublineHeight = Math.max.apply(Math, sublines.map(function() {
						return $(this).outerHeight();
					}).get()),
					maxHeight = Math.max.apply(Math, headlines.map(function() {
						return $(this).outerHeight();
					}).get());

				ResponsiveHub
					.on('change.mobile.enter', function() {
						headlines.css('height', 'auto');
						sublines.css('height', 'auto');
					})
					.on('change.mobile.leave', function() {
						headlines.css('height', maxHeight + 'px');
						sublines.css('height', maxSublineHeight + 'px');
					});
			});
		}
	});
});
